// Copyright (c) 2022 by Move Closer

import { ModalRegistry } from '@movecloser/front-core'
import { AsyncComponent } from 'vue'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export enum Drawers {
  Filters = 'filters'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum Modals {
  AddReviewModal = 'addReviewModal',
  AddedToFavouriteModal = 'addedToFavouriteModal',
  ProductReviewsModal = 'productReviewsModal',
  VerifyCommentsModal = 'verifyCommentsModal'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl> (edited)
 */
export const drawersRegistry = {
  [Drawers.Filters]: () => import(/* webpackChunkName: "modal/CartDrawer" */ '../../shared/molecules/FiltersDrawer/FiltersDrawer.vue')
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const modalsRegistry: ModalRegistry<AsyncComponent> = {
  [Modals.AddReviewModal]: () => import(/* webpackChunkName: "modal/AddReviewModal" */ '../organisms/AddReviewModal/AddReviewModal.vue'),
  [Modals.AddedToFavouriteModal]: () => import(/* webpackChunkName: "modal/AddedToFavouriteModal" */ '../organisms/AddedToFavouriteModal/AddedToFavouriteModal.vue'),
  [Modals.ProductReviewsModal]: () => import(/* webpackChunkName: "modal/CartDrawer" */ '../organisms/ProductReviewsModal/ProductReviewsModal.vue'),
  [Modals.VerifyCommentsModal]: () => import(/* webpackChunkName: "modal/VerifyComments" */ '../organisms/VerifyCommentsModal/VerifyCommentsModal.vue')
}
